var _path, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeTrapeze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 700,
    viewBox: "0 0 400 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 126H339.5L203 579H115V126Z",
    stroke: "white",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 350 116)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 125 116)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 213 569)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 125 569)",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 126L86.6603 141L69.3397 141L78 126ZM78 579L69.3397 564L86.6602 564L78 579ZM79.5 139.5L79.5 565.5L76.5 565.5L76.5 139.5L79.5 139.5Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115 90L130 81.3397V98.6603L115 90ZM340 90L325 98.6603V81.3397L340 90ZM128.5 88.5L326.5 88.5V91.5L128.5 91.5V88.5Z",
    fill: "#929292"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115 615L130 606.34V623.66L115 615ZM203 615L188 623.66V606.34L203 615ZM128.5 613.5H189.5V616.5H128.5V613.5Z",
    fill: "#929292"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5227 365V335.909H43.0455V348.864H58.5568V335.909H62.0795V365H58.5568V351.989H43.0455V365H39.5227Z",
    fill: "#929292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.523 70V40.9091H220.045V66.875H233.568V70H216.523ZM246.903 40.9091V70H243.38V44.6023H243.21L236.107 49.3182V45.7386L243.38 40.9091H246.903Z",
    fill: "#929292"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.523 668V638.909H144.045V664.875H157.568V668H140.523ZM162.511 668V665.443L172.114 654.932C173.241 653.701 174.169 652.631 174.898 651.722C175.627 650.803 176.167 649.941 176.517 649.136C176.877 648.322 177.057 647.47 177.057 646.58C177.057 645.557 176.811 644.671 176.318 643.923C175.835 643.175 175.172 642.598 174.33 642.19C173.487 641.783 172.54 641.58 171.489 641.58C170.371 641.58 169.396 641.812 168.562 642.276C167.739 642.73 167.099 643.369 166.645 644.193C166.2 645.017 165.977 645.983 165.977 647.091H162.625C162.625 645.386 163.018 643.89 163.804 642.602C164.59 641.314 165.66 640.311 167.014 639.591C168.378 638.871 169.907 638.511 171.602 638.511C173.307 638.511 174.817 638.871 176.134 639.591C177.45 640.311 178.482 641.281 179.23 642.503C179.978 643.724 180.352 645.083 180.352 646.58C180.352 647.65 180.158 648.696 179.77 649.719C179.391 650.732 178.728 651.864 177.781 653.114C176.844 654.354 175.542 655.869 173.875 657.659L167.341 664.648V664.875H180.864V668H162.511Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeTrapeze);
export default __webpack_public_path__ + "static/media/node_trapeze.61a9089671b75da35a94a3e6839dc5c3.svg";
export { ForwardRef as ReactComponent };